import styled, { css } from "styled-components";
import { Sidebar as SidebarLayout } from "@sonder/ui/source/styled/layouts/Sidebar";
import { Button as ButtonPrimitive } from "@sonder/ui/source/styled/primitives/Button";
import {
  backgroundHighlights,
  colors,
  sizes,
  zIndex,
} from "@sonder/ui/source/styled/theme";

export const SidebarItemBaseStyles = css`
  align-items: center;
  color: ${colors.white};
  display: flex;
  font-size: 1.75rem;
  height: 3.4rem;
  justify-content: center;
  width: 100%;
`;

export const SidebarStatic = styled.div`
  ${SidebarItemBaseStyles}
  color: ${colors.grayF};
  font-weight: bold;
  margin-bottom: 4rem;
  user-select: none;
`;

export const SidebarDivider = styled.div`
  height: 1px;
  background: #ffffff52;
  flex: 1;
`;

export const SidebarSpacer = styled.div`
  ${SidebarItemBaseStyles}
  height: 1.45rem;
`;

export const SidebarPusher = styled.div`
  flex: 1;
`;

export interface SidebarButtonProps {
  selected?: boolean;
}
export const SidebarButton = styled(ButtonPrimitive)<SidebarButtonProps>`
  ${SidebarItemBaseStyles}
  position: relative;
  z-index: 0;

  > svg {
    font-size: inherit;
  }

  &:after {
    background: rgba(0, 0, 0, 0);
    background: ${props => props.selected && "rgba(0, 0, 0, 0.3)"};
    content: "";
    height: 100%;
    position: absolute;
    width: 100%;
    z-index: -1;
  }
  &:disabled {
    opacity: 0.4;
  }
  &:hover:not(:disabled) {
    cursor: ${props => props.selected && "initial"};
    &:after {
      background: rgba(0, 0, 0, 0.15);
      background: ${props => props.selected && "rgba(0, 0, 0, 0.3)"};
    }
  }
  &:active:not(:disabled):after {
    background: rgba(0, 0, 0, 0.3);
  }
`;

interface SidebarProps {
  expanded?: boolean;
}

export const SidebarBackdrop = styled.div<SidebarProps>`
  background: ${backgroundHighlights.active.medium};
  bottom: 0;
  left: 0;
  opacity: ${props => (props.expanded ? 1 : 0)};
  pointer-events: ${props => (props.expanded ? "all" : "none")};
  position: fixed;
  right: 0;
  top: 0;
  transition: opacity 100ms ease-in-out;
  width: 100%;
  z-index: ${zIndex.sidebar};

  @media screen and (min-width: ${sizes.minBreakpoint}) {
    opacity: 0;
    pointer-events: none;
  }
`;

export const Sidebar = styled(SidebarLayout)<SidebarProps>`
  background: ${colors.blue3};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0.75rem 0;
  position: relative;

  @media screen and (max-width: ${sizes.minBreakpoint}) {
    bottom: 0;
    grid-area: auto;
    position: fixed;
    top: 0;
    transform: ${props =>
      props.expanded ? "translateX(0)" : "translateX(-100%)"};
    transition: transform 100ms ease-in-out;
    width: 4.5rem;
    z-index: ${zIndex.sidebar};
  }
`;

export const TopBar = styled.div`
  align-items: center;
  background: ${colors.blue3};
  display: none;
  flex-direction: row;
  height: 4.5rem;
  padding: 0 1.5rem;

  @media screen and (max-width: ${sizes.minBreakpoint}) {
    display: flex;
  }
`;
